import BaseComponent from '/webresources-sources/js/components/base-component';
import JSShare from 'js-share';
import { defineComponent } from "/webresources-sources/js/util/jquery";

export default class ShareBarComponent extends BaseComponent {
	events() {
		return {
			'[data-type]': {
				click: (e) => {
					return JSShare.go(e.target);
				},
			},
		};
	}
}

defineComponent('share-bar-component', ShareBarComponent);
